export default "__VITE_ASSET__CkM79jK4__"